// 法人番号(13桁)チェックデジット検証。
// app/models/concerns/corporate_number.rb と同一ロジック(サーバ側が砦、こちらは入力時の早期弾き)。
export function corporateNumberValid(number) {
  const str = String(number == null ? '' : number);
  if (!/^\d{13}$/.test(str)) return false;

  const digits = str.split('').map(Number);
  const check = digits[0];
  const base = digits.slice(1); // 12桁 最上位→最下位
  let sum = 0;
  base.slice().reverse().forEach(function (d, idx) {
    sum += d * (((idx + 1) % 2 === 1) ? 1 : 2);
  });
  return check === (9 - (sum % 9));
}
